<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal success_popup" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <!-- Modal-Header -->
        <!-- <div class="modal_close_btn">
            <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
          </div> -->
        <!-- Modal content-->
        <div mat-dialog-content>
          <!-- Modal-Body -->
          <div class="modal-body br-8">
            <div class="modal_close_btn">
              <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
            </div>
            <div class="success_details">
              <div class="status_img">
                <img src="../../../../../assets/images/payment-success.svg" alt="" loading="eager">
              </div>
              <div class="status_content">
                <div class="payment_box">
                    <div class="payment_card">
                      <div class="payment_body">
                        <form  class="form-section payment-form-section">
                          <!-- ---------------------------- Payment Mode ----------------------------- -->
                       
                          

                          <div >

                            <ngx-stripe-card-group
                                [formGroup]="stripeTest"
                                [elementsOptions]="elementsOptions"
                              >
                                <ngx-stripe-card-number [options]="cardOptions"></ngx-stripe-card-number>
                                <ngx-stripe-card-expiry [options]="cardOptions"></ngx-stripe-card-expiry>
                                <ngx-stripe-card-cvc [options]="cardOptions"></ngx-stripe-card-cvc>

                            </ngx-stripe-card-group>

                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                <div fxLayout="column" fxLayoutAlign="center center" class="mt-20">
                  <button class="btn btn-sm global-btn" mat-button  (click)="completePayment()"
                    >Pay</button>
                </div>
                <!-- <p>By Clicking Continue</p>
                  <p>Proceed for Completing Subscription</p> -->
                <!-- <div fxLayout="column" fxLayoutAlign="center center">
                    <button class="btn btn-sm global-btn" mat-button [routerLink]="['']"
                      (click)="tabMove()">Continue</button>
                  </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  